<ng-template let-extraClass="extraClass" #topNav>
  @if (!isRightSideContent && !windowService.isDesktopRes) {
    <tidy-top-nav
      [title]="'Past Job'"
      [class]="extraClass"
      [canGoBack]="true"
      [customBack]="backPage" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper>
    @if (!isRightSideContent && windowService.isDesktopRes) {
      <tidy-desktop-header [isLoading]="!loaded && !loadError">
        <div class="wrappable-container">
          <tidy-image
            [src]="'assets/svg/arrow-back-black.svg'"
            (action)="goBack()"
            class="desktop-back-icon" />
          <tidy-text [title]="'Past Job'" />
          @if (!loadError) {
            <tidy-small-button
              [text]="'Copy Public Link'"
              [image]="'assets/svg/link-white.svg'"
              (click)="copyPublicLink()" />
            <tidy-small-button
              [text]="'Print PDF'"
              [image]="'assets/svg/printer-white.svg'"
              (click)="printPdf()" />
          }
        </div>
      </tidy-desktop-header>
    }

    @if (errorMessage) {
      <tidy-error-message [text]="errorMessage" />
    }

    @if (loadError) {
      <tidy-card>
        @if (loadError === 'guest-account') {
          <tidy-row class="extra-bottom-padding">
            <tidy-text [header]="'Sign in to see this job'" />
          </tidy-row>
          <tidy-row class="extra-bottom-padding">
            <tidy-text [body]="'This job belongs to the TIDY account that booked it. Sign in with that account\'s email or phone to see its details, photos and bill.'" />
          </tidy-row>
          <tidy-button
            [text]="'Sign In'"
            [action]="signInToJobAccount"
            class="primary" />
        }
        @if (loadError === 'no-access') {
          <tidy-row class="extra-bottom-padding">
            <tidy-text [header]="'You can\'t see this job'" />
          </tidy-row>
          <tidy-row class="extra-bottom-padding">
            <tidy-text [body]="'This job belongs to another TIDY account, or to a property you don\'t have access to. Sign in with the account that booked it, or ask the account owner for access.'" />
          </tidy-row>
          <tidy-button
            [text]="'Go to Job History'"
            [action]="goToJobHistory"
            class="primary" />
        }
        @if (loadError === 'failed') {
          <tidy-row class="extra-bottom-padding">
            <tidy-text [header]="'We couldn\'t load this job'" />
          </tidy-row>
          <tidy-row class="extra-bottom-padding">
            <tidy-text [body]="'Check your connection and try again.'" />
          </tidy-row>
          <tidy-button
            [text]="'Try Again'"
            [action]="retryLoad"
            class="primary" />
        }
      </tidy-card>
    }

    @if (loaded) {
      <ion-row>
        <ion-col
          [sizeLg]="!isRightSideContent && windowService.isDesktopRes && (hasPro || activity?.length > 0) ? 8 : 12"
          [sizeSm]="!isRightSideContent && windowService.isDesktopRes && (hasPro || activity?.length > 0) ? 6 : 12">
          @if (isRightSideContent) {
            <tidy-row [align]="'center'" style="margin-bottom: 1rem;">
              <tidy-text
                [body]="'Print PDF'"
                class="link"
                (action)="printPdf()" />
            </tidy-row>
          }
          <tidy-card>
            <tidy-row [alignLastItemRight]="true">
              <tidy-image
                [src]="job?.booking?.bookable_service?.icon_url"
                class="header-size" />
              <tidy-text
                [header]="(job?.job?.service_type_details?.name || job?.booking?.bookable_service?.name) | titlecase" />
              <tidy-text
                [body]="job?.job?.date | parseDateTime: 'EEE MMM d'" />
            </tidy-row>
            <tidy-row [alignLastItemRight]="true" class="extra-bottom-padding">
              <tidy-text
                  [helper]="displayAddress"
                  [translate]="false" />
                <tidy-text
                  [helper]="job?.job?.start_time | parseDateTime: 'h:mma'" />
            </tidy-row>
            @if (jobEvents?.length) {
              <div style="margin-bottom: 2rem;">
                @for (event of jobEvents; track event) {
                  @if (event?.event?.name === 'samantha_service.booking.created') {
                    <tidy-row>
                      <tidy-text
                        [body]="event?.text + (' on ' | translate) + (event?.happened_at | parseDateTime:'MMM d':'local') + (' at ' | translate) + (event?.happened_at | parseDateTime:'h:mma':'local')" />
                    </tidy-row>
                  }
                }
              </div>
            }
            @if (hasPro) {
              <tidy-row>
                @for (pro of job?.homekeepers; track pro) {
                  <tidy-row class="vertical-align-center">
                    <tidy-initials-icon
                      style="margin-right: 5px"
                      [fullName]="item?.pro?.first_name + ' ' + (item?.pro?.last_name ? item?.pro?.last_name : '')" />
                    <tidy-text
                      [body]="pro?.first_name"
                      [translate]="false" />
                  </tidy-row>
                }
              </tidy-row>
            }
            @if (!hasPro) {
              <tidy-row class="vertical-align-center">
                <tidy-image
                  [src]="'assets/svg/person-circle-outline.svg'"
                  class="body-size" />
                <tidy-text [body]="'Cleaning canceled by you'" />
              </tidy-row>
            }
          </tidy-card>

          @if (hasPro && isRightSideContent || !windowService.isDesktopRes) {
            <tidy-card style="padding: 0px">
              <div [attr.id]="'map' + job?.job?.id" #map style="width: 100%; height: 300px; border-radius: 6px;"></div>
            </tidy-card>
          }

          @if (isRentalClient) {
            <tidy-card>
              <tidy-row class="vertical-align-center">
                <tidy-image
                  [src]="'assets/img/task-list.svg'"
                  class="header-size" />
                <tidy-text [header]="'Tasks'" />
              </tidy-row>
              <tidy-row class="vertical-align-middle">
                @if (tasksService.tasksLoaded && tasksService.linkedTasks.length === 0) {
                  <tidy-text [body]="'None linked'" />
                }
                @if (tasksService.tasksLoaded && tasksService.linkedTasks.length > 0) {
                  <ng-container class="vertical-align-middle">
                    @for (task of tasksService.linkedTasks; track task; let last = $last) {
                      <tidy-text
                        [body]="task.title"
                        (action)="tasksService.goToTask(task.id)"
                        class="link" />
                      @if (!last) {
                        <span>, &nbsp;</span>
                      }
                    }
                  </ng-container>
                }
                @if (!tasksService.tasksLoaded) {
                  <ion-skeleton-text
                    animated
                    style="margin-top: 5px; width: 80px; height: 13px" />
                }
                @if (showTasksDropdown) {
                  <tidy-task-dropdown
                    [priorPage]="'past-job'"
                    [priorPageParams]="isRightSidePanelAlreadyOpen ? {jobId: jobId} : null"
                    [bookingId]="job?.booking?.id"
                    [addressId]="job?.address?.id"
                    [jobId]="job?.job?.id" />
                }
              </tidy-row>
            </tidy-card>
          }

          @if (isRightSideContent || !windowService.isDesktopRes) {
            <tidy-card>
              <tidy-card-button (action)="goToShareJobPage()">
                <tidy-row class="vertical-align-center">
                  <tidy-image
                    [src]="'assets/img/paper-plane.svg'"
                    class="header-size" />
                  <tidy-text [header]="'Share Job Link'" />
                </tidy-row>
              </tidy-card-button>
            </tidy-card>
          }

          @if (loaded && hasPro && job?.job?.state !== 'cancelled') {
            <feedback
              [cleaningId]="cleaningId"
              [pros]="job?.homekeepers"
              [feedback]="feedback"
              [isCleaningJob]="job?.job?.service_type_details?.key?.includes('regular_cleaning') || job?.booking?.bookable_service?.key?.includes('regular_cleaning')"
              (panelClosed)="onFeedbackPanelClosed()" />
          }

          <parking-reimbursement (approvedParkingReimbursement)="reloadBilling()" [cleaningId]="cleaningId" />

          @if (isRightSideContent || !windowService.isDesktopRes) {
            @for (item of activity; track item) {
              <tidy-card>
                <tidy-row class="extra-bottom-padding" [alignLastItemRight]="true">
                  <div>
                    <tidy-initials-icon
                      [fullName]="item?.pro?.text"
                      style="margin-right: 5px;" />
                    <tidy-text
                      [header]="item?.pro?.text ? item?.pro?.text : (item?.pro?.first_name + ' ' + (item?.pro?.last_name ? item?.pro?.last_name : ''))"
                      [translate]="false" />
                  </div>
                  <div style="position: relative; margin-left: 5px">
                    @if (item?.pro?.first_name) {
                      <tidy-image
                        [src]="'assets/img/messages.svg'"
                        class="title-size white-icon"
                        (action)="goToMessageThreadPage(item?.pro)" />
                    }
                    @if (item?.numberOfUnreadMessages > 0) {
                      <div style="position: absolute; top: -8px; right: -8px; background: #CB393C; color: white; border-radius: 50%; min-width: 18px; height: 18px; display: flex; align-items: center; justify-content: center; font-size: 12px; padding: 0 4px; font-family: Inter, Arial, sans-serif;">
                        {{item?.numberOfUnreadMessages}}
                      </div>
                    }
                  </div>
                </tidy-row>
                @for (update of item?.updates; track update) {
                  <tidy-row>
                    <message [message]="update" />
                  </tidy-row>
                }
              </tidy-card>
            }
          }

          @if (pendingDispute) {
            <tidy-card>
              <tidy-card-button (action)="goToDisputeResolution()">
                <tidy-row class="vertical-align-center">
                  <tidy-image
                    [src]="'assets/img/yellow-alert.svg'"
                    class="header-size" />
                  <tidy-text
                    [header]="pendingDisputeTitle" />
                </tidy-row>
                <tidy-row>
                  <tidy-text
                    [body]="pendingDisputeBody" />
                </tidy-row>
              </tidy-card-button>
            </tidy-card>
          }

          @if (hasPro) {
            <tidy-card>
              <tidy-row class="vertical-align-center">
                <tidy-image
                  [src]="'assets/img/question.svg'"
                  class="header-size" />
                <tidy-text [header]="'Need Help?'" />
              </tidy-row>
              @for (pro of job?.homekeepers; track pro) {
                <tidy-card-button (action)="markNoShow(pro?.first_name, pro?.id)">
                  <tidy-row class="vertical-align-center">
                    <tidy-text
                      [body]="pro?.first_name"
                      [translate]="false" /><span>&nbsp;</span>
                    <tidy-text [body]="'Never Arrived'" />
                  </tidy-row>
                </tidy-card-button>
              }
              <tidy-card-button (action)="printPdf()">
                <tidy-row class="vertical-align-center">
                  <tidy-text [body]="'View / Print Invoice'" />
                </tidy-row>
              </tidy-card-button>
              <tidy-card-button (action)="goToOtherIssuePage()">
                <tidy-row class="vertical-align-center">
                  <tidy-text [body]="'Other Issue'" />
                </tidy-row>
              </tidy-card-button>
            </tidy-card>
          }

          <tidy-card>
            <tidy-row class="vertical-align-center">
              <tidy-image
                [src]="'assets/img/credit-card.svg'"
                class="header-size" />
              <tidy-text [header]="'Billing Breakdown'" />
            </tidy-row>
            <tidy-row class="extra-bottom-padding">
              <tidy-text [helper]="'What you were billed for this.'" />
            </tidy-row>
            @if (billingInfo?.amount_cleaning) {
              <tidy-row>
                <tidy-text [body]="(billingInfo.amount_cleaning | tcurrency) + ' '" />
                <tidy-text [body]="'Cost'" /><span>&nbsp;</span>
                @if (billingInfo?.full_paid === true) {
                  <tidy-text [body]="'(paid in full)'" />
                }
                @if (billingInfo?.full_paid === false && job?.job?.state === 'cancelled') {
                  <tidy-text [body]="'(cancellation fee)'" />
                }
                @if (billingInfo?.full_paid === false && job?.job?.status === 'incomplete') {
                  <tidy-text [body]="'(paid in half)'" />
                }
                @if ((billingInfo?.cleaning_state == 'cancelled' || billingInfo?.cleaning_state == 'cancelled_once') && billingInfo?.booking_id !== null) {
                  <tidy-text [body]="' '" />
                  <tidy-text
                    [actionBody]="'Waive Fee'"
                    (action)="waiveFee(billingInfo?.booking_id)"
                    class="link" />
                }
              </tidy-row>
            }
            @for (tip of tips; track tip) {
              <tidy-row>
                <tidy-text [body]="'+ ' + (tip?.amount | tcurrency)" /><span>&nbsp;</span>
                <tidy-text [body]="'Tip'" /><span>&nbsp;</span>
                @if (tip?.proName) {
                  <tidy-text
                    [body]="'for'"
                    [translate]="false" /><span>&nbsp;</span>
                  <tidy-text
                    [body]="tip?.proName | shortName"
                    [translate]="false" /><span>&nbsp;</span>
                }
                @if (tip?.status === 'pending') {
                  <tidy-text
                    [body]="'Edit Tip'"
                    (action)="newTip(tip?.homekeeper_job_id, tip?.proName)"
                    class="link" />
                }
              </tidy-row>
            }
            @for (parkingReimbursement of parkingReimbursements; track parkingReimbursement) {
              <tidy-row>
                <tidy-text [body]="'+ ' + (parkingReimbursement?.amount | tcurrency)" /><span>&nbsp;</span>
                <tidy-text [body]="'Parking Reimbursement for'" /><span>&nbsp;</span>
                <tidy-text
                  [body]="parkingReimbursement?.proName"
                  [translate]="false" />
              </tidy-row>
            }
            <tidy-row>
              <tidy-text [body]="'= ' + ((billingInfo?.ammountUsedSum) | tcurrency)" /><span>&nbsp;</span>
              <tidy-text [body]="'Total'" />
            </tidy-row>
          </tidy-card>

          <tidy-card>
            <tidy-row class="vertical-align-center">
              <tidy-image
                [src]="'assets/img/bank.svg'"
                class="header-size" />
              <tidy-text [header]="'Payment Breakdown'" />
            </tidy-row>
            <tidy-row class="extra-bottom-padding">
              <tidy-text [helper]="'What you already paid for this.'" />
            </tidy-row>
            @for (item of billingInfo?.details; track item) {
              <tidy-row [alignLastItemRight]="true">
                <tidy-text [body]="item?.amount_used | tcurrency" /><span>&nbsp;</span>
                <tidy-text [body]="'of'" /><span>&nbsp;</span>
                <tidy-text [body]="item?.amount | tcurrency" /><span>&nbsp;</span>
                <tidy-text [body]="'charge'" />
                <tidy-text [helper]="item?.date | parseDateTime: 'MMM d'" />
              </tidy-row>
            }
          </tidy-card>

          @if (rooms?.length > 0) {
            <tidy-row class="extra-bottom-padding">
              <tidy-text [header]="'Checklist'" />
            </tidy-row>

            @if (bookingNote?.length || bookingFormAnswers?.length) {
              <tidy-card>
                <tidy-card-button [hideArrow]="true">
                  <tidy-row class="vertical-align-center">
                    <tidy-image
                      [src]="'assets/img/information.svg'"
                      class="title-size" />
                    <tidy-text [header]="'Job Note'" />
                  </tidy-row>
                  @for (note of bookingNote; track note) {
                    <tidy-row>
                      @if (note?.type == 'text') {
                        <tidy-text [body]="note?.text" />
                      }
                      @if (note?.type == 'image') {
                        <tidy-image [src]="note?.media_url" />
                      }
                      @if (note?.type == 'video') {
                        <tidy-image [src]="note?.media_url" />
                      }
                    </tidy-row>
                  }
                  @for (answer of bookingFormAnswers; track answer) {
                    @if (answer?.template_input?.type == 'text' || answer?.template_input?.type == 'text_area') {
                      <tidy-row>
                        <tidy-text [body]="answer?.template_input?.label + ': ' + answer?.data?.value" />
                      </tidy-row>
                      @if (answer?.template_input?.image_url) {
                        <tidy-photo-note [src]="answer?.template_input?.image_url" />
                      }
                    }
                    @if (answer?.template_input?.type == 'select') {
                      <tidy-row>
                        <tidy-text [body]="answer?.template_input?.label + ': ' + me.getBookingFormSelectValue(answer?.data?.value)" />
                      </tidy-row>
                      @if (answer?.template_input?.image_url) {
                        <tidy-photo-note [src]="answer?.template_input?.image_url" />
                      }
                    }
                    @if (answer?.template_input?.type == 'multiselect') {
                      <tidy-row>
                        <tidy-text [body]="answer?.template_input?.label + ': ' + me.getBookingFormMultiselectValue(answer?.data?.value)" />
                      </tidy-row>
                      @if (answer?.template_input?.image_url) {
                        <tidy-photo-note [src]="answer?.template_input?.image_url" />
                      }
                    }
                    @if (answer?.template_input?.type == 'file' && answer?.template_input?.data?.type == 'image') {
                      <tidy-row>
                        <tidy-text [body]="answer?.template_input?.label" />
                      </tidy-row>
                      <tidy-carrousel
                        class="photo-notes-carrousel only-padding-bottom"
                        [scaleImages]="true">
                        <tidy-photo-note
                          *tidyCarrousel
                          [src]="answer?.data?.value" />
                      </tidy-carrousel>
                    }
                    @if (answer?.template_input?.type == 'files' && answer?.template_input?.data?.type == 'images') {
                      <tidy-row>
                        <tidy-text [body]="answer?.template_input?.label" />
                      </tidy-row>
                      <tidy-carrousel
                        class="photo-notes-carrousel only-padding-bottom"
                        [scaleImages]="true">
                        @for (imageUrl of answer?.data?.value; track imageUrl) {
                          <tidy-photo-note
                            *tidyCarrousel
                            [src]="imageUrl" />
                        }
                      </tidy-carrousel>
                    }
                  }
                </tidy-card-button>
              </tidy-card>
            }

            <tidy-card>
              <div style="display: flex; align-items: center; justify-content: space-between;">
                <div style="display: flex; align-items: center;">
                  <tidy-image
                    [src]="'assets/img/camera.svg'"
                    class="header-size" />
                  <tidy-text [header]="'Before Photos / Videos'" />
                </div>
                @if (isFullWidth) {
                  <div style="display: flex; align-items: center;">
                    <tidy-file-upload
                      [accept]="'image/*'"
                      [showPreview]="false"
                      [label]="isNativeMobile ? 'Upload Photo' : 'Add Photo'"
                      (addedImagesChange)="uploadPhoto($event, 'before_job')"
                      [showTextLink]="true"
                      style="margin-right: 10px" />
                    <tidy-file-upload
                      [accept]="'video/mp4'"
                      [showPreview]="false"
                      [label]="isNativeMobile ? 'Upload Video' : 'Add Video'"
                      (addedImagesChange)="uploadVideo($event, 'before_job')"
                      [showTextLink]="true" />
                  </div>
                }
              </div>
              @if (!isFullWidth) {
                <div style="margin-top: 10px; display: flex; align-items: center; align-items: center;">
                  @if (isNativeMobile) {
                    <tidy-text
                      [actionBody]="'Take Photo'"
                      (action)="takePhoto('before_job')"
                      class="link"
                      style="margin-right: 10px" />
                  }
                  <tidy-file-upload
                    [accept]="'image/*'"
                    [showPreview]="false"
                    [label]="isNativeMobile ? 'Upload Photo' : 'Add Photo'"
                    (addedImagesChange)="uploadPhoto($event, 'before_job')"
                    [showTextLink]="true"
                    style="margin-right: 10px" />
                  @if (isNativeMobile) {
                    <tidy-text
                      [actionBody]="'Take Video'"
                      (action)="takeVideo('before_job')"
                      class="link"
                      style="margin-right: 10px" />
                  }
                  <tidy-file-upload
                    [accept]="'video/mp4'"
                    [showPreview]="false"
                    [label]="isNativeMobile ? 'Upload Video' : 'Add Video'"
                    (addedImagesChange)="uploadVideo($event, 'before_job')"
                    [showTextLink]="true" />
                </div>
              }
              @if (beforePhotos?.length == 0) {
                <tidy-row class="extra-top-padding">
                  <tidy-text [helper]="'None Added'" />
                </tidy-row>
              }
              <ion-row>
                @for (item of beforePhotos; track item; let i = $index) {
                  <ion-col [size]="isFullWidth ? 6 : 12">
                    @if (item.mediaType === 'video') {
                      <tidy-row>
                        <tidy-video
                          class="before-after-video"
                          [src]="item?.url"
                          style="width: 100%; height: auto; max-width: 100%;" />
                      </tidy-row>
                    }
                    @if (item.mediaType === 'photo') {
                      @if (item?.url) {
                        <tidy-photo-note
                          class="full-width no-margin photo-note-job"
                          [src]="item?.url"
                          style="width: 100%; height: auto; max-width: 100%;" />
                      }
                    }
                    @if (item?.metadata || item?.uploadedBy) {
                      <div class="timestamp-caption">
                        <tidy-row [alignLastItemRight]="true">
                          <tidy-text
                            [smallBody]="'Uploaded by:'"
                            class="white" /><span>&nbsp;</span>
                          <tidy-text
                            [smallBody]="item?.uploadedBy ? item?.uploadedBy : 'You'"
                            class="white" />
                          <div>
                            <tidy-image
                              [src]="'assets/img/trash-outline-white.svg'"
                              (action)="removePhoto(item, i, 'before_job')"
                              class="body-size"
                              style="cursor: pointer" />
                          </div>
                        </tidy-row>
                        @if (item?.metadata?.location) {
                          <tidy-row>
                            <tidy-text
                              [smallBody]="'Location:'"
                              class="white" />
                            <tidy-text
                              [smallBody]="item?.metadata?.location"
                              class="white" />
                          </tidy-row>
                        }
                        @if (item?.metadata?.displayDate) {
                          <tidy-row>
                            <tidy-text
                              [smallBody]="'Timestamp:'"
                              class="white" />
                            <tidy-text
                              [smallBody]="(item?.metadata?.displayDate | parseDateTime: 'ddd MMM d') + ' ' + (item?.metadata?.displayDate | parseDateTime: 'h:mma')"
                              class="white" />
                          </tidy-row>
                        }
                      </div>
                    }
                  </ion-col>
                }
              </ion-row>
            </tidy-card>

            <job-checklist-display
              [rooms]="rooms"
              [jobId]="cleaningId"
              [toDosProvider]="toDosProvider" />
          }

          <!-- Restocking results for this job (card gCUZuCjf). -->
          @if (restockTasks?.length > 0) {
            <tidy-row class="vertical-align-center">
              <tidy-image
                [src]="'assets/svg/cube-outline.svg'"
                class="header-size" />
              <tidy-text [header]="'Restocking'" />
            </tidy-row>
            <restock-tasks-display [tasks]="restockTasks" />
          }

          <tidy-card>
            <div style="display: flex; align-items: center; justify-content: space-between;">
              <div style="display: flex; align-items: center;">
                <tidy-image
                  [src]="'assets/img/camera.svg'"
                  class="header-size" />
                <tidy-text [header]="'After Photos / Videos'" />
              </div>
              @if (isFullWidth) {
                <div style="display: flex; align-items: center;">
                  <tidy-file-upload
                    [accept]="'image/*'"
                    [showPreview]="false"
                    [label]="isNativeMobile ? 'Upload Photo' : 'Add Photo'"
                    (addedImagesChange)="uploadPhoto($event, 'after_job')"
                    [showTextLink]="true"
                    style="margin-right: 10px" />
                  <tidy-file-upload
                    [accept]="'video/mp4'"
                    [showPreview]="false"
                    [label]="isNativeMobile ? 'Upload Video' : 'Add Video'"
                    (addedImagesChange)="uploadVideo($event, 'after_job')"
                    [showTextLink]="true" />
                </div>
              }
            </div>
            @if (!isFullWidth) {
              <div style="margin-top: 10px; display: flex; align-items: center; align-items: center;">
                @if (isNativeMobile) {
                  <tidy-text
                    [actionBody]="'Take Photo'"
                    (action)="takePhoto('after_job')"
                    class="link"
                    style="margin-right: 10px" />
                }
                <tidy-file-upload
                  [accept]="'image/*'"
                  [showPreview]="false"
                  [label]="isNativeMobile ? 'Upload Photo' : 'Add Photo'"
                  (addedImagesChange)="uploadPhoto($event, 'after_job')"
                  [showTextLink]="true"
                  style="margin-right: 10px" />
                @if (isNativeMobile) {
                  <tidy-text
                    [actionBody]="'Take Video'"
                    (action)="takeVideo('after_job')"
                    class="link"
                    style="margin-right: 10px" />
                }
                <tidy-file-upload
                  [accept]="'video/mp4'"
                  [showPreview]="false"
                  [label]="isNativeMobile ? 'Upload Video' : 'Add Video'"
                  (addedImagesChange)="uploadVideo($event, 'after_job')"
                  [showTextLink]="true" />
              </div>
            }
            @if (afterPhotos?.length == 0) {
              <tidy-row class="extra-top-padding">
                <tidy-text [helper]="'None Added'" />
              </tidy-row>
            }
            <ion-row>
              @for (item of afterPhotos; track item; let i = $index) {
                <ion-col [size]="isFullWidth ? 6 : 12">
                  @if (item.mediaType === 'video') {
                    <tidy-row>
                      <tidy-video
                        class="before-after-video"
                        [src]="item?.url"
                        style="width: 100%; height: auto; max-width: 100%;" />
                    </tidy-row>
                  }
                  @if (item.mediaType === 'photo') {
                    @if (item?.url) {
                      <tidy-photo-note
                        class="full-width no-margin photo-note-job"
                        [src]="item?.url"
                        style="width: 100%; height: auto; max-width: 100%;" />
                    }
                  }
                  @if (item?.metadata || item?.uploadedBy) {
                    <div class="timestamp-caption">
                      <tidy-row [alignLastItemRight]="true">
                        <tidy-text
                          [smallBody]="'Uploaded by:'"
                          class="white" /><span>&nbsp;</span>
                        <tidy-text
                          [smallBody]="(item?.uploadedBy ? (item?.uploadedBy | translate) : ('You' | translate))"
                          class="white" />
                        <div>
                          <tidy-image
                            [src]="'assets/img/trash-outline-white.svg'"
                            (action)="removePhoto(item, i, 'after_job')"
                            class="body-size"
                            style="cursor: pointer" />
                        </div>
                      </tidy-row>
                      @if (item?.metadata?.location) {
                        <tidy-row>
                          <tidy-text
                            [smallBody]="'Location:'"
                            class="white" /><span>&nbsp;</span>
                          <tidy-text
                            [smallBody]="item?.metadata?.location"
                            class="white" />
                        </tidy-row>
                      }
                      @if (item?.metadata?.displayDate) {
                        <tidy-row>
                          <tidy-text
                            [smallBody]="'Timestamp:'"
                            class="white" /><span>&nbsp;</span>
                          <tidy-text
                            [smallBody]="(item?.metadata?.displayDate | parseDateTime: 'ddd MMM d') + ' ' + (item?.metadata?.displayDate | parseDateTime: 'h:mma')"
                            class="white" />
                        </tidy-row>
                      }
                    </div>
                  }
                </ion-col>
              }
            </ion-row>
          </tidy-card>
        </ion-col>

        @if (!isRightSideContent && windowService.isDesktopRes && (hasPro || activity?.length > 0)) {
          <ion-col [sizeLg]="4" [sizeSm]="6">
            @if (hasPro) {
              <tidy-card style="padding: 0px">
                <div [attr.id]="'map' + job?.job?.id" #map style="width: 100%; height: 300px; border-radius: 6px;"></div>
              </tidy-card>
            }
            @for (item of activity; track item) {
              <tidy-card>
                <tidy-row class="extra-bottom-padding" [alignLastItemRight]="true">
                  <div>
                    <tidy-initials-icon
                      [fullName]="item?.pro?.first_name + ' ' + (item?.pro?.last_name ? item?.pro?.last_name : '')"
                      style="margin-right: 5px;" />
                    <tidy-text
                      [header]="item?.pro?.text ? item?.pro?.text : (item?.pro?.first_name + ' ' + (item?.pro?.last_name ? item?.pro?.last_name : ''))"
                      [translate]="false" />
                  </div>
                  <div style="position: relative; margin-left: 5px">
                    @if (item?.pro?.first_name) {
                      <tidy-image
                        [src]="'assets/img/messages.svg'"
                        class="title-size white-icon"
                        (action)="goToMessageThreadPage(item?.pro)" />
                    }
                    @if (item?.numberOfUnreadMessages > 0) {
                      <div style="position: absolute; top: -8px; right: -8px; background: #CB393C; color: white; border-radius: 50%; min-width: 18px; height: 18px; display: flex; align-items: center; justify-content: center; font-size: 12px; padding: 0 4px; font-family: Inter, Arial, sans-serif;">
                        {{item?.numberOfUnreadMessages}}
                      </div>
                    }
                  </div>
                </tidy-row>
                @for (update of item?.updates; track update) {
                  <tidy-row>
                    <message [message]="update" />
                  </tidy-row>
                }
              </tidy-card>
            }
          </ion-col>
        }
      </ion-row>
    }
  </tidy-wrapper>
</ng-template>

@if (!isRightSideContent) {
  <app-scroll-wrapper [isfullWidthContent]="windowService.isDesktopRes" [templateContent]="content" />
}

@if (isRightSideContent) {
  <ion-content class="ion-content-right-column">
    <ng-container *ngTemplateOutlet="content" />
  </ion-content>
}

